import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import accountLeftTree from './components/left-tree.vue';
import accountRightTable from './components/right-table.vue';
let default_1 = class extends Vue {
    toAccount() {
        this.$router.push('/setting/account/role');
    }
};
default_1 = __decorate([
    Component({
        name: 'userManagement',
        components: {
            accountLeftTree,
            accountRightTable,
        },
        i18n: {
            messages: {
                en: {
                    roleManagement: 'Role Management',
                },
                zh: {
                    roleManagement: '角色管理',
                },
            },
        },
    })
], default_1);
export default default_1;
